import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { G4DynamicDataEdit } from "./edit";
import { G4DynamicDataNew } from "./new";
import { G4DynamicDataTable } from "./table";

export default function G4DynamicData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | G4 Dynamic Data");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<G4DynamicDataEdit />} />
      <Route index element={<G4DynamicDataTable />} />
      <Route path="new" element={<G4DynamicDataNew />} />
    </Routes>
  );
}
